export const FORM_FIELD_LABELS = {
    REQUIRED_FIRST_NAME: "forms.fieldTitle.requiredFirstName",
    REQUIRED_LAST_NAME: "forms.fieldTitle.requiredLastName",
    REQUIRED_WORK_EMAIL: "forms.fieldTitle.requiredWorkEmail",
    REQUIRED_PHONE_NUMBER: "forms.fieldTitle.requiredPhoneNumber",
    REQUIRED_COMPANY_SIZE: "forms.fieldTitle.RequiredCompanySize",
    FIRST_NAME: "forms.fieldTitle.firstName",
    LAST_NAME: "forms.fieldTitle.lastName",
    WORK_EMAIL: "forms.fieldTitle.workEmail",
    PHONE_NUMBER: "forms.fieldTitle.phoneNumber",
    COMPANY_SIZE: "forms.fieldTitle.companySize"
};
export const HUBSPOT_FIELD_LABELS = {
    JOB_TITLE: "contactSales.hubspotForm.form.fieldTitle.jobTitle",
    REQUIRED_COMPANY_NAME: "contactSales.hubspotForm.form.fieldTitle.requiredCompanyName",
    COMPANY_NAME: "contactSales.hubspotForm.form.fieldTitle.companyName",
    HOW_CAN_HELP_TITLE: "contactSales.hubspotForm.form.fieldTitle.howCanHelp",
    HOW_CAN_HELP_PLACEHOLDER: "contactSales.hubspotForm.form.fieldPlaceholder.howCanHelp",
    HOW_CAN_HELP_FLOATING_LABEL: "contactSales.hubspotForm.form.fieldLabel.howCanHelp",
    HOW_PLAN_TO_USE_TITLE: "contactSales.hubspotForm.form.fieldTitle.howPlanToUse",
    PRODUCT_QUESTION: "contactSales.hubspotForm.form.fieldTitle.productQuestion",
    SHORTER_REQUIRED_PRODUCT_AI_QUESTION: "contactSales.hubspotForm.form.fieldTitle.shorterRequiredProductAIQuestion",
    COUNTRY: "contactSales.hubspotForm.form.productQuestion.country",
    WHAT_TO_ACHIEVE: "contactSales.hubspotForm.form.fieldTitle.whatToAchieve",
    WHAT_TO_ACHIEVE_MENU_HEADER: "contactSales.hubspotForm.form.whatToAchieve.menuHeader"
};
export const FORM_ERROR_MESSAGES = {
    JOB_TITLE: "contactSales.hubspotForm.form.fieldErrorMsg.jobTitle",
    REQUIRED: "forms.requiredError",
    EMAIL: "forms.emailField.errorMessage",
    PHONE: "forms.phoneField.errorMessage",
    DETAILS_FIELD_REQUIRED: "forms.detailsField.requiredSoWeCanHelpError",
    SELECT_AT_LEAST_ONE: "forms.productQuestion.selectAtLeastOneError"
};
export const FORM_PLACEHOLDERS = {
    SELECT: "forms.fields.selectPlaceholder"
};
